<template>
  <div class="more-apps">
    <div class="flex align-center title">
      <h2>{{ info.language_list.more.title }}</h2>
      <i
        class="iconfont icon-youjiantou"
        @click="handleConfirm"></i>
    </div>
    <div class="app-lists">
      <div
        v-for="(item, index) in moreApps"
        :key="index"
        class="app-item flex justify-between align-center"
        @click="handleConfirm">
        <img :src="item.icon" />
        <div>
          <p>{{ item.name }}</p>
          <div>{{ item.num }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import MysticPotion from '@/assets/images/mystic.png';
import Pinata from '@/assets/images/pinata.png';
import Zombie from '@/assets/images/Zombie.png';
import Tesouro from '@/assets/images/tesouro.png';
import Jelly from '@/assets/images/jelly.png';
import Baloot from '@/assets/images/Baloot.png';
import Okey from '@/assets/images/okey.png';

const moreApps = [
  {
    name: 'Mystic Potion',
    icon: MysticPotion,
    num: '4.5',
  },
  {
    name: 'Pinata Wins',
    icon: Pinata,
    num: '3.5',
  },
  {
    name: 'Zombie Outbreak',
    icon: Zombie,
    num: '3.8',
  },
  {
    name: 'Tesouro Slots',
    icon: Tesouro,
    num: '4.0',
  },
  {
    name: 'Jelly Boom Slots',
    icon: Jelly,
    num: '2.9',
  },
  {
    name: 'Baloot',
    icon: Baloot,
    num: '3.2',
  },
  {
    name: 'Okey 101',
    icon: Okey,
    num: '4.2',
  },
];

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};
</script>
<style lang="scss" scoped>
.more-apps {
  .app-lists {
    margin-top: 24px;
    display: grid;
    grid-gap: 25px;
    grid-template-columns: repeat(auto-fill, 100px);
    padding-bottom: 24px;
    .app-item {
      img {
        width: 56px;
        height: 56px;
        margin-right: 10px;
      }
      div {
        font-size: 12px;
      }
      p {
        line-height: 15px;
      }
    }
  }
}
</style>
